"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondsToTimeframeString = exports.nowInSeconds = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
const nowInSeconds = () => Math.floor(Date.now() / 1000);
exports.nowInSeconds = nowInSeconds;
function secondsToTimeframeString(seconds) {
    const months = Math.floor(seconds / (60 * 60 * 24 * 30));
    if (months > 0) {
        return `${months} month${months > 1 ? 's' : ''}`;
    }
    const weeks = Math.floor(seconds / (24 * 60 * 60 * 7));
    if (weeks > 0) {
        return `${weeks} week${weeks > 1 ? 's' : ''}`;
    }
    const days = Math.floor(seconds / (24 * 60 * 60));
    if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''}`;
    }
    const hours = Math.floor(seconds / (60 * 60));
    if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''}`;
    }
    const minutes = Math.floor(seconds / 60);
    return `${minutes} minute${minutes > 1 ? 's' : ''}`;
}
exports.secondsToTimeframeString = secondsToTimeframeString;
//# sourceMappingURL=dateFormat.js.map